import type { AbstractControl } from '@angular/forms';
import moment from 'moment';

export function germanDateValidator(AC: AbstractControl) {
  if (AC?.value && !moment(AC.value, 'DD.MM.YYYY', true).isValid()) {
    return { date: true };
  }
  return null;
}
